import React from 'react';
// import Max_placholder from '../public/Max_placeholder.jpg'

const teamMembers = [
  {
    name: 'Max Porter',
    position: 'Founder & CEO',
    description: 'I am the solo founder of the company. I ensure that all operations run smoothly and efficiently.',
    image: '/images/Max_placeholder.jpg'
  }
];

const AboutSection = () => {
  return (
    <section id="about" className="py-12 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-semibold text-black mb-6" data-aos="fade-down">About Me</h2>
        <div className="md:w-1/2" data-aos="fade-left">
          <p className="mb-6 text-gray-700">
            Max Hauling is a newly formed top-notch junk removal service. I am committed to helping you declutter your space quickly and efficiently. I pride myself on professionalism and customer satisfaction.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {teamMembers.map((member, index) => (
            <div key={index} className="p-6 bg-blue-100 rounded-md shadow-md text-center" data-aos="fade-right">
              <img src={member.image} alt={member.name} className="w-32 h-32 rounded-full mx-auto mb-4" />
              <h3 className="text-xl font-bold text-black mb-2">{member.name}</h3>
              <p className="text-blue-500 mb-2">{member.position}</p>
              <p className="text-gray-700">{member.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutSection